// extracted by mini-css-extract-plugin
export var label = "_e5-2";
export var slideContainer = "_e5-0";
export var slider = "_e5-1";